// OnboardingSoloWise.tsx
import {
  IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonButton,
  IonFooter, IonProgressBar, IonItem, IonLabel, IonInput, IonCheckbox,
  IonTextarea, IonSelect, IonSelectOption, IonText,
  useIonViewWillEnter,
  IonImg,
  IonCard,
  IonCardContent,
  IonCol,
  IonGrid,
  IonRow,
  IonCardHeader,
  IonButtons,
  useIonViewDidEnter,
  useIonRouter,
  IonNote,
  IonIcon,
  IonList,
  IonToggle
} from "@ionic/react";
//import type { HTMLIonContentElement } from "@ionic/core";
import { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore from "swiper";
import "swiper/css";
import './Onboarding.css';
//import { Preferences } from "@capacitor/preferences";
import { useAppContext } from "../AppProvider";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Alert, AlertTitle } from "@mui/material";
import WelcomeImg from '../assets/images/onboard-welcome.png';
import ContactImg from '../assets/images/onboard-contact.png';
//import PlaceImg from '../assets/images/onboard-place.png';
import PermissionsImg from '../assets/images/onboard-permissions.png';
import FinalImg from '../assets/images/onboard-final.png'
import { caretForward, checkmarkCircleOutline, warningOutline } from "ionicons/icons";
import { Link } from 'react-router-dom';
import { VAPID_PUBLIC_KEY, urlBase64ToUint8Array } from '../lib/PushClient';
import { Geolocation, Position } from '@capacitor/geolocation';
import { Capacitor } from '@capacitor/core';

const Onboarding: React.FC = () => {
    const [index, setIndex] = useState<number>(0);
    const swiperRef = useRef<SwiperCore | null>(null);
    const contentRef = useRef<HTMLIonContentElement | null>(null);
    const [nextDisabled, setNextDisabled] = useState<boolean>(false);

    const { authenticateMember, authorizedMember, setShowLoader, getTimezones, loading, setLoading, } = useAppContext();

    const router = useIonRouter();

    //
    // Authenticate Member
    //
    useIonViewWillEnter(() => {  
        document.body.classList.remove('dark');
        setShowLoader(true);  
        const authenticate = async () => {
            const authenticated = await authenticateMember();  
            //console.log(authenticated);
            if(!authenticated || authenticated.mt == '') router.push('/login', 'forward');
            else {
                await getTimezones(); 
                setShowLoader(false);
            } 
        };
        authenticate();
    }); 
    

    /*const nextButtonText = (i:any) => {
        switch(i) {
            case 0: return 'Next: Enter a Contact';
            case 1: return 'Next: Enter a Place';
            case 2: return 'Next: Set Your Preferences';
            case 3: return 'Finish';
            case 4: return 'Next: Enter a Route';
            case 5: return 'Next: Enter a Vehicle';
            default: return '';
        }
    }*/

    const nextButtonText = (i:any) => {
        switch(i) {
            case 0: return 'Enter a Contact';
            case 1: return 'Set Your Preferences';
            case 2: return 'Finish';
            default: return '';
        }
    }

    /*const next = async () => {  
        //console.log(index);
        swiperRef.current?.slideNext();
        contentRef.current?.scrollToTop(0);
        //console.log(index, authorizedMember.profiles.contacts, authorizedMember.profiles.places, nextDisabled);
        //setNextDisabled(true);
        switch (index) {
            case 0: setNextDisabled(authorizedMember.profiles.contacts === 0); break; 
            case 1: setNextDisabled(authorizedMember.profiles.places === 0); break; 
            case 2: setNextDisabled(false); break;
            case 3: setNextDisabled(false); break;
            case 4: setNextDisabled(false); break;
            case 5: setNextDisabled(false); break;
            default: setNextDisabled(false);
        }
    };*/

    const next = async () => {  
        swiperRef.current?.slideNext();
        contentRef.current?.scrollToTop(0);
        //setNextDisabled(true);
        switch (index) {
            case 0: setNextDisabled(false); //(authorizedMember.profiles.contacts === 0); break; 
            case 1: setNextDisabled(false); break;
            case 2: setNextDisabled(false); break;
            case 3: setNextDisabled(false); break;
            case 4: setNextDisabled(false); break;
            default: setNextDisabled(false);
        }
    };

    const handleNextDisabled = (val:boolean) => {
        //console.log(index, val);
        setNextDisabled(val);
        contentRef.current?.scrollToTop(0);
    };

    const back = () => {
        contentRef.current?.scrollToTop(0);
        swiperRef.current?.slidePrev();
    }

    const submit = () => {
        console.log('submit');
    };

    return (
        <IonPage>
            <IonContent fullscreen ref={contentRef} id='OnboardingContent'>                    
                {index >= 0 &&
                <IonProgressBar color={index/3 === 1 ? 'success' : 'secondary'} buffer={1} value={index/3} />
                } 
                <IonGrid fixed>
                    <IonRow class='ion-justify-content-center'>
                        <IonCol size='12' sizeMd='10' sizeLg='10' sizeXl='10'>
                            <Swiper
                                onSwiper={(s) => (swiperRef.current = s)}
                                onSlideChange={(s) => setIndex(s.activeIndex)}
                                allowTouchMove={false}
                                slidesPerView={1}
                            >
                                <SwiperSlide><Intro /></SwiperSlide>
                                <SwiperSlide><EmergencyContact authorizedMember={authorizedMember} onContactSaved={handleNextDisabled} /></SwiperSlide>
                                {/*<SwiperSlide><Place authorizedMember={authorizedMember} onPlaceSaved={handleNextDisabled} /></SwiperSlide>*/}
                                <SwiperSlide><Permissions/></SwiperSlide>
                                <SwiperSlide><Final/></SwiperSlide>
                            </Swiper>
                        </IonCol>
                    </IonRow>
                </IonGrid>                              
                
            </IonContent>

            {index < 3 &&
            <IonFooter className="ion-padding" id="OnboardingFooter" translucent={false}>
                <div className="ion-text-center">
                    {index > 0 && <IonButton color={'tertiary'} fill="outline" onClick={back}>Back</IonButton>}
                    <IonButton 
                        color={'secondary'} 
                        disabled={nextDisabled}
                        onClick={index < 3 ? next : submit}>
                            {nextButtonText(index)} 
                            <IonIcon icon={caretForward} slot="end"></IonIcon>
                    </IonButton>
                </div>
            </IonFooter>
            }
        </IonPage>
    );
};


// 
// Intro Screen
//

function Intro() {
  const { SWFullHorizLogo, textLogoLoaded, fadeInTextLogo } = useAppContext();

  return (
    <>
        <div className='ion-text-center'>
            <img src={WelcomeImg} alt='SoloWise' style={{'maxWidth': '200px'}} />
        </div>
        <h1 className="ion-no-margin">Welcome to</h1>
        <div className="ion-text-center">
            <IonImg className={textLogoLoaded ? 'fade-in' : 'fade-out'} src={SWFullHorizLogo} onIonImgDidLoad={fadeInTextLogo} style={{'margin': '0 auto', 'maxWidth': '200px'}}></IonImg>
        </div>
        <IonCard>
            <IonCardContent className="ion-text-center">
                {/* Wistia or local clip; swap in your embed */}
                {/* <video controls playsInline style={{ width: "100%", borderRadius: 12 }}>
                    <source src="/assets/onboarding/welcome.mp4" type="video/mp4" />
                </video> */}
                <h1>SoloWise alerts those who care about you if you don't check in.</h1> 
                <hr />
                <IonText color="dark">
                    <p className="ion-text-justify">Whether you're hitting the trail for a solo adventure, going out on a first date, meeting a new client one-on-one, or just living independently, SoloWise creates an extra layer of connection that provides peace of mind for you and the people who care about you.</p>

                    
                    <hr />
                    <p><strong>We'll get your account set up in a few quick steps.</strong></p>
                    <h2> Let's get started!</h2>
                </IonText>
            </IonCardContent>
        </IonCard>
    </>
  );
}


//
// Emergency Contact Screen
//

type EmergencyContactProps = {
    authorizedMember: any;
    onContactSaved: (val: boolean) => void;
};

type ContactForm = {
  firstName: string;
  lastName: string;
  email: string;
};

function EmergencyContact({ authorizedMember, onContactSaved }: EmergencyContactProps) {
    const [form, setForm] = useState<ContactForm>({
        firstName: '',
        lastName: '',
        email: '',
    });

    const [alertVisible, setAlertVisible] = useState<boolean>(false);
    const [contactSaved, setContactSaved] = useState<boolean>(false);
    const toggleAlertContent = () => setAlertVisible(!alertVisible);

    const { authKey, showToast } = useAppContext();

    const handleChange =
    (field: keyof ContactForm) =>
    (e: CustomEvent) => {
      const value = (e.detail as any).value ?? '';
      setForm((prev) => ({ ...prev, [field]: value }));
    };
    
    const insertContact = async () => {
        const btn: any = document.getElementById('contactFormSubmit');
        btn.innerHTML = 'Sending...';
        btn.setAttribute('disabled', '');

        const formData = new FormData();
        formData.append('contactFirstName', form.firstName);
        formData.append('contactLastName', form.lastName);
        formData.append('contactEmail', form.email);
        formData.append('mt', authKey.mt);
        
        try {
            const response = await fetch('https://api.besolowise.com/contacts/insert/', {
                method: 'POST',
                credentials: 'include',
                body: formData
            });
            if(response.ok) {
                const obj = await response.json(); 
                btn.innerHTML = 'Save';
                btn.removeAttribute('disabled');
                    
                if(obj.success) {
                    //console.log('Contact was saved');
                    setContactSaved(true);
                    onContactSaved(false);
                } else {
                    showToast({
                        message: 'Error: ' + obj.message,
                        duration: 2500,
                        color: 'danger',
                    });
                }
            } else {
                btn.innerHTML = 'Save';
                btn.removeAttribute('disabled');
                showToast({
                    message: 'Response Error',
                    duration: 2000,
                    color: 'danger',
                });
            } 
        } catch(error) {
            showToast({
                message: 'Connection Error: Couldn\'t create this contact. ' + error + '. Try again.',
                duration: 3000,
                color: 'danger',
                position: 'middle'
            });
        }   
    };

    return (
      <>
        <div className='ion-text-center'>
            <img src={ContactImg} alt='Set ip an Emergency Contact' style={{'maxWidth': '200px'}} />
        </div>
        <h1 className='ion-no-margin'>Enter a<br />SoloWise Contact</h1>
        <div className='ion-padding'>   
            <Alert
                severity="info"
                icon={<InfoOutlinedIcon fontSize="inherit" />}
                onClick={toggleAlertContent}
                sx={{
                    borderRadius: 2,
                    mb: 2,
                    cursor: 'pointer'
                }}
            >
                <AlertTitle>What is a SoloWise Contact?</AlertTitle>
                {alertVisible &&
                    (<div className='ion-margin-top'>
                        <p>A <strong>SoloWise Contact</strong> must be someone whom you know and trust to forward critical information to the proper authorities during an emergency situation. You will need to enter the full name and email address for your SoloWise Contact. You must create at least one SoloWise Contact before you can schedule a check-in.</p>
                        <p>Before you send an emergency contact agreement by submitting this form, we strongly suggest informing the recipient to expect an email from SoloWise. Otherwise, an unexpected email from us could appear as spam to someone not aware of our service. This could cause the recipient to decline or delete the email. By informing your contact to expect the email, you can increase the odds of your contact accepting your request on the first attempt.</p>
                    </div>)
                }
            </Alert>
        </div>
        <IonCard>
            <IonCardContent>
                {}
                {contactSaved || (authorizedMember?.profiles !== undefined && authorizedMember?.profiles.contacts > 0)
                    ? <>
                        <div className="ion-text-center">
                            <IonIcon className="x-large" color={'success'} icon={checkmarkCircleOutline}></IonIcon>
                        </div>
                        <h2 className="ion-text-center"><IonText color={'success'}>Done.</IonText></h2>
                        <hr />
                        <p className="ion-text-center"><strong>It could still take some time for your Contact to respond to your request, so let's keep going on your end. Click the Next button, below.</strong></p>
                      </>
                    : <>
                          <IonGrid>
                            <IonRow>
                                <IonCol size='12'>
                                    <IonLabel color={'dark'}><b>Name</b></IonLabel>
                                </IonCol>
                                <IonCol size='6'>
                                    <IonInput fill='outline' name='contactFirstName' placeholder='First Name' type='text' onIonInput={handleChange('firstName')}></IonInput>
                                </IonCol>
                                <IonCol size='6'>
                                    <IonInput fill='outline' name='contactLastName' placeholder='Last Name' type='text' onIonInput={handleChange('lastName')}></IonInput>
                                </IonCol>                                   
                            </IonRow>

                            <IonRow>
                                <IonCol size='12'>
                                    <IonLabel color={'dark'}><b>Email</b></IonLabel>
                                </IonCol>
                                <IonCol size='12'>
                                    <IonInput fill='outline' name='contactEmail' placeholder='Email Address' type='email' onIonInput={handleChange('email')}></IonInput>                                        
                                </IonCol>
                            </IonRow>

                            <IonRow className='ion-margin-top'>
                                <IonCol size='12'>
                                    <input type="hidden" name="contactAlwaysUse" value="1" />
                                </IonCol>
                            </IonRow>
                        </IonGrid>                    
                        <IonButton className='ion-margin-top' color={'secondary'} expand="block" id='contactFormSubmit' onClick={insertContact}>
                            Send Contact Agreement
                        </IonButton>
                    </>
                }
            </IonCardContent>
        </IonCard>
      </>
    );
}


//
// Place Screen
//

type PlaceProps = {
    authorizedMember: any;
    onPlaceSaved: (val: boolean) => void;
};

type PlaceForm = {
  name: string;
  timezone: string;
  dst: string;
  location: string;
};

/*function Place({ authorizedMember, onPlaceSaved }: PlaceProps) {
    const [form, setForm] = useState<PlaceForm>({
        name: '',
        timezone: '',
        dst: '',
        location: '',
    });

    const [alertVisible, setAlertVisible] = useState<boolean>(false);
    const [infoVisible, setInfoVisible] = useState<boolean>(false);
    const [placeSaved, setPlaceSaved] = useState<boolean>(false);
    const { authKey, timezones, userTimezone, showToast } = useAppContext();
    const toggleAlertContent = () => setAlertVisible(!alertVisible);
    const toggleInfoContent = () => setInfoVisible(!infoVisible);
    
    const handleChange =
    (field: keyof PlaceForm) =>
    (e: CustomEvent) => {
      const value = (e.detail as any).value ?? '';
      setForm((prev) => ({ ...prev, [field]: value }));
    };

    const insertPlace = async () => {        
        const btn: any = document.getElementById('placeFormSubmit');
        btn.innerHTML = 'Saving...';
        btn.setAttribute('disabled', '');
        
        const formData = new FormData();
        formData.append('placeName', form.name);
        formData.append('placeTimezone', form.timezone);
        formData.append('placeUsesDST', form.dst);
        formData.append('placeLocation', form.location);        
        formData.append('placePhone', ''); 
        formData.append('placePropertyType', ''); 
        formData.append('placeEnvType', ''); 
        formData.append('placeMapLink', ''); 
        formData.append('placeConnectivity', ''); 
        formData.append('placeOtherInfo', ''); 
        formData.append('mt', authKey.mt);
        
        try {
            const response = await fetch('https://api.besolowise.com/places/insert/', {
                method: 'POST',
                credentials: 'include',
                body: formData
            });
            
            if(response.ok) {
                const obj = await response.json(); 
                
                if(obj.success) {
                    //console.log('Place was saved');
                    setPlaceSaved(true);
                    onPlaceSaved(false);
                } else {
                    btn.innerHTML = 'Save';
                    btn.removeAttribute('disabled');
                    showToast({
                        message: 'Error: ' + obj.message,
                        duration: 3000,
                        color: 'danger',
                    });
                }
            } else {
                btn.innerHTML = 'Save';
                btn.removeAttribute('disabled');
                showToast({
                    message: 'Response Error. Try again.',
                    duration: 3000,
                    color: 'danger',
                });
            } 
        } catch(error) {
            showToast({
                message: 'Connection Error: Couldn\'t create this place. ' + error + '. Try again.',
                duration: 3000,
                color: 'danger',
                position: 'middle'
            });
        }       
    };

    return (
    <>
        <div className='ion-text-center'>
            <img src={PlaceImg} alt='Set ip a Place' style={{'maxWidth': '200px'}} />
        </div>
        <h1 className='ion-no-margin'>Enter a<br />SoloWise Place</h1>
        <div className='ion-padding'>   
            <Alert
                severity="info"
                icon={<InfoOutlinedIcon fontSize="inherit" />}
                onClick={toggleAlertContent}
                sx={{
                    borderRadius: 2,
                    mb: 2,
                    cursor: 'pointer'
                }}
            >
                <AlertTitle>What is a SoloWise Place?</AlertTitle>
                {alertVisible &&
                    <div className='ion-margin-top'>
                        <p>A <strong>SoloWise Place</strong> is a saved location that represents where you plan to be, or where a Route begins or ends. It adds a reference point to your Timers and helps responders quickly orient to your location if an alert is triggered. Many members enter "Home" as their first Place, but it can be wherever fits your needs.</p>
                    </div>
                }
            </Alert>
        </div>
        <IonCard>
            <IonCardContent>
                {placeSaved || (authorizedMember?.profiles !== undefined && authorizedMember?.profiles.places > 0)
                    ? <>
                        <div className="ion-text-center">
                            <IonIcon className="x-large" color={'success'} icon={checkmarkCircleOutline}></IonIcon>
                        </div>
                        <h2 className="ion-text-center"><IonText color={'success'}>Done.</IonText></h2>
                        <hr />
                        <p className="ion-text-center"><strong>You can also create Routes in SoloWise, so you can set a check-in time for when you expect to arrive at your destination. Look for "Routes" in your Account Menu after this initial walk-through.</strong></p>
                      </>
                    : <>
                        <IonGrid>
                            <IonRow className='ion-margin-bottom'>
                                <IonCol size='12'>
                                    <IonLabel color={'dark'}><b>Name</b></IonLabel>
                                    <IonNote>Examples: "Home", "Work", "Some Trailhead"</IonNote>
                                </IonCol>
                                <IonCol size='12'>
                                    <IonInput autoCapitalize='sentences' fill='outline' name='placeName' placeholder='' type='text' onIonInput={handleChange('name')} maxlength={50}></IonInput>                                        
                                </IonCol>                                  
                            </IonRow>
                            <IonRow className='ion-margin-bottom'>
                                <IonCol size='12' sizeLg='6'>
                                    <IonLabel color={'dark'}><b>Timezone</b></IonLabel>                                
                                    <IonSelect className="ion-margin-bottom" fill='outline' labelPlacement='stacked' name='placeTimezone' placeholder='Select a Timezone' value={form.timezone} onIonChange={handleChange('timezone')}>
                                        <IonSelectOption value=''>Select</IonSelectOption>
                                        {timezones.map((zone: any, index: number) => (
                                            <IonSelectOption key={index} value={zone[0]}>{zone[1]}</IonSelectOption>
                                        ))}                                            
                                    </IonSelect>
                                </IonCol>                             
                                <IonCol size='12' sizeLg='6'>
                                    <IonLabel color={'dark'}><b>Observes Daylight Savings Time (DST)</b></IonLabel>                                
                                    <IonSelect fill='outline' labelPlacement='stacked' name='placeUsesDST' value={form.dst} onIonChange={handleChange('dst')}>
                                        <IonSelectOption value=''>Select</IonSelectOption>
                                        <IonSelectOption value='0'>Never (Arizona & Hawaii)</IonSelectOption>
                                        <IonSelectOption value='1'>Seasonally (most U.S. states)</IonSelectOption> 
                                    </IonSelect>
                                </IonCol>                               
                            </IonRow>

                            <IonRow className='ion-margin-bottom'>
                                <IonCol size='12'>
                                    <IonLabel color={'dark'}><b>Address / Location</b></IonLabel>
                                    <IonNote>This can be a Street Address, GPS Coordinates, or just a good description.</IonNote>
                                </IonCol>
                                <IonCol size='12'>
                                    <IonTextarea autoCapitalize='sentences' autoGrow={true} fill='outline' name='placeLocation' placeholder='' onIonInput={handleChange('location')}></IonTextarea>                                                                 
                                </IonCol>
                            </IonRow>

                            <IonRow className='ion-margin-bottom'>
                                <IonCol size='12'>
                                    <div>   
                                        <Alert
                                            severity="info"
                                            icon={<InfoOutlinedIcon fontSize="inherit" />}
                                            onClick={toggleInfoContent}
                                            sx={{
                                            borderRadius: 2,
                                            mb: 2,
                                            cursor: 'pointer',
                                            }}
                                        >
                                            <AlertTitle>Why is the timezone and DST info required? Doesn't my device  automatically know that?</AlertTitle>
                                            {infoVisible &&
                                                (<div className='ion-margin-top'>
                                                    Yes, your device might know where it is right now, but SoloWise cannot presume your current timezone will be the same as the Place you're creating. For example, traveling cross-country might require creating a destination Place one or more timezones away. So, we don't even try to guess your intentions here, and we simply ask you for the information.
                                                </div>)
                                            }                        
                                            
                                        </Alert>
                                    </div>
                                </IonCol>
                            </IonRow>
                        </IonGrid>
                        
                        <IonButton className='ion-margin-top' color={'secondary'} expand="block" id='placeFormSubmit' onClick={insertPlace}>Save</IonButton>
                      </>
                }
            </IonCardContent>
        </IonCard>
    </>
    );
}*/

//
// Permissions Screen
//

function Permissions() {
    const [alertVisible, setAlertVisible] = useState<boolean>(false);
    const [pushIsGranted, setPushIsGranted] = useState<boolean>(false);
    const [sub, setSub] = useState<PushSubscription | null>(null);
    const [memberPhone, setMemberPhone] = useState<string>('');
    const phoneInputRef = useRef<any>();
    const { authKey, authorizedMember, updateMember, countries, getCountries, locationPerm, setLocationPerm, locationPermStr, setLocationPermStr, pushPermStr, setPushPermStr, showToast } = useAppContext();
    const platform = Capacitor.getPlatform();

    useIonViewDidEnter(() => {
        const didEnter = async () => {
            await getLocationPerms(); 
            await getCountries();
            const subResult = await checkPushSub(); 
            setSub(subResult);
            if (subResult !== null) setPushIsGranted(true);
        }

        document.querySelectorAll('[aria-hidden]').forEach(element => {
            //console.log(element);
            element.removeAttribute('aria-hidden');
        });  

        didEnter();                                
    });

    useEffect(() => {
        if (authorizedMember) {
            // Strip the country code from memberPhone
            const phoneWithCountryCode = `${authorizedMember.memberPhone}`; 
            const countryCode = `${authorizedMember.memberPhoneCode}`;
            
            if(countryCode != 'undefined' && countryCode != '') {
                const phoneWithoutCountryCode = phoneWithCountryCode.replace(new RegExp('^\\' + countryCode), '');        
                setMemberPhone(phoneWithoutCountryCode);
            }            
        }
    }, [authorizedMember, memberPhone]);

    const toggleAlertContent = () => setAlertVisible(!alertVisible);

    const requestLocPerms = async () => {        
        if (platform === 'web') {
            try {
                var CurrentPosition = await Geolocation.getCurrentPosition();     
                console.log(CurrentPosition);  
                setLocationPerm(true);
                setLocationPermStr('Granted');         
                return true;
            } catch (error) {
                console.error(error);
                return false;
            }
        } else {
            var req = await Geolocation.requestPermissions({permissions: ['location']});
            //console.log(req);
            if (req.location === 'granted') {
                return true;
            } 
            else return false;
            
        }
    };

    const getLocationPerms = async () => {
        const locPermObj = await Geolocation.checkPermissions();
        let permRequest: boolean | Position = false;
        let locPermStr = '';
        if (locPermObj) {
            locPermStr = locPermObj.location;
            locPermStr = locPermStr.charAt(0).toUpperCase() + locPermStr.slice(1);
            if (locPermStr === 'Granted') permRequest = true;
            //if (locPermStr !== 'Granted') permRequest = await requestLocPerms();
            //else permRequest = true;
        }
        //console.log(permRequest, locPermStr);
        
        if (permRequest) locPermStr = 'Granted';
        setLocationPerm(permRequest); 
        setLocationPermStr(locPermStr);       
    };

    const requestPushPerms = async () => {
        if (!('Notification' in window)) {
            console.warn('Notifications API not supported in this browser.');
            return;
        }
        const result = await Notification.requestPermission();
        console.log('[app] Notification permission:', result);
        
        console.log(sub);

        if (result === 'granted' && sub === null) {
            const subResult:any = await subscribe();
            setSub(subResult);
            setPushPermStr(result);
            setPushIsGranted(true);
        } else if (result === 'granted' && sub !== null) {
            await unsubscribe();
            setPushPermStr(result);
            setPushIsGranted(false);
        } else if (result == 'default' || result == 'denied') {
            setPushPermStr(result);
            setPushIsGranted(false);
        }
    };

    const subscribe = async () => {
        try {
            if (!('serviceWorker' in navigator)) throw new Error('No service worker support');
            if (!('PushManager' in window)) throw new Error('No PushManager support');

            const permission = Notification.permission;
            if (permission !== 'granted') throw new Error(`Permission is ${permission}`);

            const reg = await navigator.serviceWorker.getRegistration();
            if (!reg) throw new Error('No SW registration');

            // If already subscribed, reuse it
            if (sub) {
                console.log('[app] existing subscription:', JSON.stringify(sub.toJSON(), null, 2));
                //setSub(existing);
                await unsubscribe();
                return null;
            }

            const appServerKey = urlBase64ToUint8Array(VAPID_PUBLIC_KEY);
            const newSub = await reg.pushManager.subscribe({
                userVisibleOnly: true,
                applicationServerKey: appServerKey,
            });

            console.log('[app] new subscription:', JSON.stringify(newSub.toJSON(), null, 2));
            //setSub(newSub);

            const subJson = newSub.toJSON();

            // post to database
            const body = authKey.mt != null ? { ...subJson, mt: authKey.mt } : subJson;
            
            try {
                const res = await fetch('https://api.besolowise.com/web-push/subscribe/', {
                    method: 'POST',
                    credentials: 'include',
                    body: JSON.stringify(body),
                });
                
                if (!res.ok) {
                    //console.log('!ok'); 
                    const text = await res.text().catch(() => '');
                    throw new Error(`subscribe.php failed: ${res.status} ${res.statusText} – ${text}`);
                } else {
                    const obj = await res.json();    
                    //console.log(obj);                    
                    return newSub; //obj; // { ok, stored, updated, endpoint }
                }

            } catch(error) {
                //console.error(error);
                showToast({
                    message: 'Connection: ' + error + '',
                    duration: 2000,
                    color: 'danger',
                    position: 'bottom',
                });
            } 
            
        } catch (e: any) {
            console.error('[app] subscribe error:', e);
            showToast({
                message: 'Connection: ' + e?.message + '',
                duration: 2000,
                color: 'danger',
                position: 'bottom',
            });
        }
    };

    const checkPushSub = async () => {
        const reg = await navigator.serviceWorker.getRegistration();
        const existing = await reg?.pushManager.getSubscription();
        //console.log('[app] check existing:', existing?.toJSON?.());
        //setSub(existing ?? null);
        return existing ?? null;
    };

    const unsubscribe = async () => {
        console.log(sub);
        if (sub) {
            const ok = await sub.unsubscribe();
            console.log('[app] unsubscribed?', ok);
            localStorage.removeItem('pushSub');
            setSub(null);
            setPushIsGranted(false);
            const subJson = sub.toJSON();

            // post to database
            const body = authKey.mt != null ? { ...subJson, mt: authKey.mt } : subJson;
            
            try {
                const res = await fetch('https://api.besolowise.com/web-push/unsubscribe/', {
                    method: 'POST',
                    credentials: 'include',
                    body: JSON.stringify(body),
                });
                //console.log(res); 
                if (!res.ok) {
                    console.log('!ok'); 
                    const text = await res.text().catch(() => '');
                    throw new Error(`unsubscribe.php failed: ${res.status} ${res.statusText} – ${text}`);
                } else {
                    const obj = await res.json();    
                    //console.log(obj);             
                    return obj; // { ok, stored, updated, endpoint }
                }

            } catch(error) {
                console.error(error);
                showToast({
                    message: 'Connection: ' + error + '',
                    duration: 2000,
                    color: 'danger',
                    position: 'bottom',
                });
            }             
        }
    };
    
    const formatPhone = () => {
        const refVal = phoneInputRef.current.value;
        const formattedValue = refVal.replace(/\D/g,'');
        phoneInputRef.current.value = formattedValue; 
    };    

    const updateSetting = async (e:any) => {
        e.preventDefault();
        const elemId = e.target.id;
        let elemVal:any = false;
        if(elemId == 'geoLocToggle' ||
           elemId == 'smsToggle') {
            elemVal = e.detail.checked;
            elemVal = elemVal ? '1' : '0';
            //console.log(elemVal);
        }
        
        const formData = new FormData(); 
        formData.append('updateElement', elemId);
        formData.append('updateValue', elemVal);
        formData.append('mt', authKey.mt);
        try {
            const apiURI = 'https://api.besolowise.com/members/settings/update/';
            const response = await fetch(apiURI, {
                method: 'POST',
                credentials: 'include',
                body: formData
            });
            if(response.ok) {
                const obj = await response.json();                 
                if(obj.success) {
                    //                    
                } else {
                    showToast({
                        message: 'Data Error: Changes were not saved. Try again.',
                        duration: 2000,
                        color: 'danger',
                    });
                }
            } else {
                showToast({
                    message: 'Response Error. Try again.',
                    duration: 2000,
                    color: 'danger',
                    position: 'middle'
                });  
            }  
             
        } catch(error) {
            showToast({
                message: 'Connection: ' + error + '.',
                duration: 23000,
                color: 'danger'
            });
        }        
    };

    return (
      <>
        <div className='ion-text-center'>
            <img src={PermissionsImg} alt='Set Preferences and Permissions' style={{'maxWidth': '200px'}} />
        </div>
        <h1 className='ion-no-margin'>Set Preferences<br />and Permissions</h1>
        <div className='ion-padding'>   
            <Alert
                severity="info"
                icon={<InfoOutlinedIcon fontSize="inherit" />}
                onClick={toggleAlertContent}
                sx={{
                    borderRadius: 2,
                    mb: 2,
                    cursor: 'pointer'
                }}
            >
                <AlertTitle>Are these permissions required to use SoloWise?</AlertTitle>
                {alertVisible &&
                    (<div className='ion-margin-top'>
                        <p>No, you may decline to use location access, web browser notifications, and text messages. However, you will be declining critical features that are intended to optimize your experience with SoloWise.</p>
                    </div>)
                }
            </Alert>
        </div>
        <IonCard>
            <IonCardContent>
                <IonItem lines='none'>                    
                    <h2><strong>Location Access</strong></h2>                    
                </IonItem>
                <IonItem lines='none'>                    
                    <IonToggle checked={locationPermStr == 'Granted'} color={'success'} enableOnOffLabels={true} id='geoLocToggle' justify="space-between" onIonChange={requestLocPerms} disabled={locationPermStr == 'Denied' || locationPermStr == 'Granted'}></IonToggle>
                    <IonLabel><strong>I want to be able to save my location</strong></IonLabel>               
                </IonItem>
                <IonItem className="ion-margin-top" lines='none'>
                    <IonText><IonIcon color={'warning'} icon={warningOutline}></IonIcon> <em>Once enabled, the only way to turn off location access is through your web browser settings.</em></IonText>
                </IonItem>
                <hr />
                
                {platform === 'web' &&
                  <>                    
                    <IonItem lines='none'>                    
                        <h2><strong>Web Push Notifications</strong></h2>                    
                    </IonItem>

                    <IonItem lines='none'>          
                        <IonToggle checked={pushIsGranted} color={'success'} enableOnOffLabels={true} id='pushToggle' labelPlacement="end" onIonChange={sub === null ? requestPushPerms : unsubscribe} disabled={pushPermStr === 'denied'}></IonToggle>
                        <IonLabel><strong>I want to receive web browser notifications</strong></IonLabel>           
                    </IonItem>
                    <IonItem className="ion-margin-top" lines='none'>
                        <IonText><IonIcon color={'warning'} icon={warningOutline}></IonIcon> <em>You will only receive notifications to remind you to check in to your Timers. Your web browser must remain active to receive notifications. Notification subscriptions must be set for each separate device and web browser on which you use SoloWise.</em></IonText>
                    </IonItem> 
                                   
                    {pushPermStr === 'denied' &&
                    <IonItem lines='none'>                                            
                        <IonNote color={'danger'}>Your current web browser is blocking SoloWise push notifications. You must enable push notifications in your browser before subscribing to SoloWise push notifications.</IonNote>                                              
                    </IonItem>
                    }  

                    <hr />
                  </>
                }                

                <IonItem lines='none'>                    
                    <h2><strong>Text Messages</strong></h2> 
                </IonItem>
                <IonItem lines='none'>                    
                    <p><strong><em>Members outside the U.S.</em></strong> might require additional configuration to receive text messages. If you find that you're not receiving text messages when expected, contact our support team right away for assistance.</p>                    
                </IonItem>
                <IonItem lines='none'>                    
                    <IonToggle checked={authorizedMember.memberSMSAgree == '1'} color={'success'} enableOnOffLabels={true} id='smsToggle' onIonChange={updateSetting}></IonToggle> 
                    <IonLabel><strong>I want to receive text messages at the following mobile phone number</strong></IonLabel> 
                </IonItem>
                <IonItem>
                    <IonLabel><strong>Mobile Phone</strong></IonLabel>
                </IonItem>
                <IonItem lines="none">
                    <form name='phoneForm' onSubmit={updateMember} style={{width: '100%'}}>
                        <IonSelect fill='outline' label='Country Code' labelPlacement='stacked' name='memberPhoneCode' placeholder='' style={{ display: 'block', marginTop: '10px' }} value='+1'>
                            <IonSelectOption value='+1'>+1 (U.S. and Canada)</IonSelectOption>
                            {countries.map((country:any, index:any) => (
                                <IonSelectOption key={index} value={country['dial_code']}>{country['dial_code']} ({country['countries_name']})</IonSelectOption>
                            ))}
                        </IonSelect>
                        <IonInput 
                            className='ion-margin-bottom ion-margin-top' 
                            fill='outline' 
                            label='Mobile Phone Number' 
                            labelPlacement='stacked' 
                            name='memberPhone' 
                            onKeyUp={formatPhone} 
                            placeholder='' 
                            ref={phoneInputRef} 
                            type='tel' 
                            value={memberPhone === undefined ? '' : memberPhone}>
                        </IonInput>
                        <IonButton className="ion-margin-bottom" color={'secondary'} expand="block" id='phoneFormSubmit' type='submit'>Save Phone Number</IonButton>
                    </form>
                </IonItem>
                 
                <IonItem className="ion-margin-top" lines="none">    
                    <IonText color={'dark'}><IonIcon color={'warning'} icon={warningOutline}></IonIcon> <em>By selecting this option and entering your mobile phone number, you are agreeing to receive text messages from SoloWise, for the sole purpose of reminding you to check in at your pre-scheduled times. You will never receive notifications or messages of an advertising nature from us. Consent is not a condition of your account usage. Please open and read the following policies for more details. You can opt-out of receiving notifications and/or messages under Account Settings.</em></IonText>
                </IonItem>
                 
                <IonItem className="ion-margin-top" lines="none"> 
                    <ul>
                        <li className='link' id='privacyLink'><Link to={'/privacy-policy'} dir='forward'>Read our Privacy Policy</Link></li>
                        <li className='link' id='termsLink'><Link to={'/terms-conditions-policy'} dir='forward'>Read our Terms and Conditions of Use Policy</Link></li>                                            
                    </ul>
                </IonItem>                   
                
            </IonCardContent>
        </IonCard>
      </>
    );
}


function Final() {
  
  return (
    <>
        <div className='ion-text-center'>
            <img src={FinalImg} alt='SoloWise' style={{'maxWidth': '200px'}} />
        </div>
        <h1 className='ion-no-margin'><IonText color={'success'}>All done!</IonText></h1>
        <IonCard>
            <IonCardContent>
                <h2 className="ion-margin-bottom">You've entered the basic components to set a SoloWise Timer.</h2> 
                <hr />
                <p className="ion-text-justify">While you wait for your Contact to accept your request, you can explore your SoloWise account screens to learn about additional features, including setting up Places, Routes, Vehicles, and other preferences.</p>
                <hr />
                <div className="ion-text-center">
                    <IonButton color={'secondary'} routerLink='/account/dashboard'>
                        Go to my Dashboard
                        <IonIcon icon={caretForward} slot="end"></IonIcon>
                    </IonButton>
                </div>                
            </IonCardContent>
        </IonCard>
    </>
  );
}


export default Onboarding;